import React, { useEffect, useState } from 'react';

//import MasonryLayout from './MasonryLayout';
import { feedQuery, searchQuery } from '../lib/data';
import Spinner from '../components/Spinner';
import { useRouter } from 'next/router'
import {useStateContext} from '../context/StateContext';


const Search = () => {
  const router = useRouter()
  let searchquery = router.keyword
  const {customer, searchTerm, setSearchTerm} = useStateContext();

return(
  <div>{searchTerm}</div>
)
}

/*


const Search = ({ searchTerm }) => {
  const [pins, setPins] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchTerm !== '') {
      setLoading(true);
      const query = searchQuery(searchTerm.toLowerCase());
      sanityClient.fetch(query).then((data) => {
        setPins(data);
        setLoading(false);
      });
    } else {
      sanityClient.fetch(feedQuery).then((data) => {
        setPins(data);
        setLoading(false);
      });
    }
  }, [searchTerm]);

  return (
    <div>

      {loading && <Spinner message="Searching pins" />}
      {pins?.length !== 0 && <MasonryLayout pins={pins} />}
      {pins?.length === 0 && searchTerm !== '' && !loading && (
        <div className="mt-10 text-center text-xl ">No Pins Found!</div>
      )}
    </div>
  );
};
*/
export default Search;